import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { CollectionStoreState } from '../../../../CollectionPanel';
import { createCollection } from '../../../../CollectionPanel/redux/actionCreators';
import {
  getNewFolderNameBlacklist,
  getIsNewCollectionSaving,
} from '../../../../CollectionPanel/redux/selectors';
import { Props } from './NewCollectionPopup';

export type StateProps = Pick<Props, 'folderNameBlacklist' | 'isSaving'>;
export type DispatchProps = Pick<Props, 'createCollection'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  CollectionStoreState
> = (state, { isPrivateCollections }) => ({
  folderNameBlacklist: getNewFolderNameBlacklist(state, isPrivateCollections),
  isSaving: getIsNewCollectionSaving(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  createCollection,
};

export default connect(mapStateToProps, mapDispatchToProps);
